module.exports = __webpack_public_path__ + "img/SC6-cover-estimate.689aad70.png";